import Dashboard from "./dashboard-page";

export default Dashboard;